// @flow
import React from 'react';
import classNames from 'classnames';
import isVideo from 'shared/lib/isVideo';

type Image = {
  url: string,
  size: string
};

type Props = {
  classes: Object,
  images: Array<Image>,
  currentSlide: number,
  sliderGoTo: Function
};

const getImageName = (url) => {
  const pathParts = url.split('/');

  return pathParts.pop();
};

class ThumbnailRow extends React.Component<Props> {
  props: Props = this.props;

  container = React.createRef<HTMLElement>();

  getPosition = () => {
    const { currentSlide } = this.props;
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    let toLeftDistance;

    let containerLeftPos;

    if (this.container.current) {
      toLeftDistance = this.container.current.childNodes[currentSlide].getBoundingClientRect().left - this.container.current.getBoundingClientRect().left;
      containerLeftPos = viewportWidth / 2 - toLeftDistance;
    }

    return {
      left: (containerLeftPos) ? `${containerLeftPos}px` : '50%'
    };
  };

  render() {
    const { classes: c, images, sliderGoTo } = this.props;

    return (
      <div
        className={c.thumbnailRow}
        style={this.getPosition()}
        ref={this.container}
      >
        {images.map((image, i) => {
          const imageName = getImageName(image.url);

          let returnedImage;

          if (isVideo(image.url)) {
            if (image.coverUrl) {
              returnedImage = <img
                key={imageName}
                src={image.coverUrl}
                alt={imageName}
                playsInline
                role="presentation"
                className={classNames(c.thumbImage, c.videoThumbnail)}
                onClick={() => sliderGoTo(i)}
              />;
            } else {
              returnedImage = <video
                key={imageName}
                src={image.url}
                playsInline
                role="presentation"
                className={classNames(c.thumbImage, c.videoThumbnail)}
                onClick={() => sliderGoTo(i)}
              />;
            }
          } else {
            returnedImage = <img
              key={imageName}
              src={image.url}
              alt={imageName}
              role="presentation"
              className={c.thumbImage}
              onClick={() => sliderGoTo(i)}
            />;
          }

          return returnedImage;
        })}
      </div>
    );
  }
}

export default ThumbnailRow;
